import { NGXLogger } from 'ngx-logger';

import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { AppEnvService, ElementControlService } from '../../core/services';

const PLUGIN_ELEMENT_CONTROL_CONFIG_URL = 'assets/env/element-control.json';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public static readonly envConfig: any = AppEnvService.staticEnvConfig;
  public static elementControlConfig: any = null;
  public static logger: NGXLogger;

  constructor(private httpBackend: HttpBackend, private _logger: NGXLogger) {
    AppService.logger = _logger;
  }

  static get enableAAD(): boolean {
    return this.envConfig?.azureAD?.enabled ?? false;
  }

  load(): Promise<void> {
    this._logger.info('Load app information begin');
    const promise = new Promise<void>((resolve, reject) => {
      const plugins: string[] = AppService.envConfig?.plugins ?? [
        'ElementControl',
      ];
      if (plugins.length > 0) {
        this.loadPluginConfigs().subscribe({
          next: (result) => {
            resolve();
          },
          error: (err) => {
            reject(err);
          },
        });
      } else {
        resolve();
      }
    });

    return promise;
  }

  private loadPluginConfigs(): Observable<void> {
    this._logger.info('Load plugin configs');
    const tasks = [
      fetch(PLUGIN_ELEMENT_CONTROL_CONFIG_URL).then((resp) => resp.json()),
    ];
    const observable = new Observable<void>((observer) => {
      combineLatest(tasks).subscribe({
        next: (results) => {
          ElementControlService.elementControlConfig = results[0];
          observer.next();
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
    return observable;
  }
}
